<template>
    <div class="pt15">
        <div class="sub_title">
           취소이력
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">취소요청일</td>
                    <td colspan="3">
                        <div class="d_block">

                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">취소사유</td>
                    <td colspan="3">
                        <div class="d_block">
                            <el-input type="textarea"   v-model="memo" rows="5"
                                      resize="none" placeholder="배송메시지를 입력해주세요."></el-input>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="c_t_title">취소요청 철회일</td>
                    <td colspan="3">
                        <div class="d_block">

                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">거절사유</td>
                    <td colspan="3">
                        <div class="d_block">
                            <el-input type="textarea"   v-model="memo" rows="5"
                                      resize="none" placeholder="배송메시지를 입력해주세요."></el-input>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "CancelHistoryLayout",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            memo:'',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
